module.exports = __webpack_public_path__ + "static/media/ico-new-cases.6c4b914e.svg";